// Same-origin /api by default: local dev proxy or the production reverse proxy.
const backend = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
export const API = backend.endsWith("/api") ? backend : `${backend}/api`;
